import "./RobotaxiOperatorRegistration.module.css";
import Header from "@/reusable_sections/Header";
import DiscoverItalianBrewingArt from "./sections/DiscoverItalianBrewingArt";
import SupportOchKontakt from "./sections/SupportOchKontakt";
import InformationOmRobotaxi from "./sections/InformationOmRobotaxi";
import Footer from "@/reusable_sections/Footer";
export default function RobotaxiOperatorRegistrationPage() {
  return <div>
      <Header />
      <DiscoverItalianBrewingArt />
      <SupportOchKontakt />
      <InformationOmRobotaxi />
      <Footer />
    </div>;
}